import { downloadFile } from '@/utils/http/http.service';
import Http from '@/utils/http/index';

export default {
  /**
   * 结算批次查询列表
   */
  getSettlementBatch(params) {
    return Http.get('/merchant/settlement/settlementBatchList', { params });
  },
  /**
   * 结算批次下载
   */
  async downloadSettlementBatch(params) {
    return Http.get('/merchant/settlement/settlementBatchDownload', { params });
  },
};
